import i18n from "i18next";

import type { ProfessionalStatus } from "api/services/admin/schemas";

export function translateProfessionalStatus(status: ProfessionalStatus): string {
  const keyMap: Record<ProfessionalStatus, string> = {
    active: i18n.t("admin.status.active"),
    deleted: i18n.t("admin.status.deleted"),
    in_onboarding: i18n.t("admin.status.in_onboarding"),
  };

  return keyMap[status] || status;
}
